import { Navigate } from 'react-router-dom';

// hooks
import useAuth from 'hooks/useAuth';
import useDynamicConfig from 'hooks/useDynamicConfig';

// ==============================|| INDEX REDIRECT ||============================== //
// Reads auth/role state reactively so isLoggedIn/activeRole changes don't need to be
// dependencies of the top-level router's useMemo (see routes/index.tsx).

const IndexRedirect = () => {
  const { isLoggedIn, activeRole } = useAuth();
  const { DEFAULT_ROLE_BASED_PATH } = useDynamicConfig();

  return <Navigate to={isLoggedIn && activeRole ? (DEFAULT_ROLE_BASED_PATH[activeRole.user_role_type_id] ?? '/settings') : 'login'} />;
};

export default IndexRedirect;
